import { render, staticRenderFns } from "./SerialPortService.vue?vue&type=template&id=35975278&scoped=true&"
import script from "./SerialPortService.vue?vue&type=script&lang=js&"
export * from "./SerialPortService.vue?vue&type=script&lang=js&"
import style0 from "./SerialPortService.vue?vue&type=style&index=0&id=35975278&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35975278",
  null
  
)

export default component.exports